import { isFleetDomain } from "../config/productConfig";
import { manualAluno } from "./manualAluno";
import { manualInstrutor } from "./manualInstrutor";
import { manualAdmin } from "./manualAdmin";
import { manualAerofleet } from "./manualAerofleet";

// slug -> manual. "fleet" marca o manual do produto de frota: é o único visível no domínio Aerofleet
// (onde nada pode revelar a plataforma de treino) e fica fora da lista do domínio de treino.
export const MANUALS = {
  aluno: { title: "Manual do Aluno", subtitle: "Treino, exames, progresso e subscrição", source: manualAluno, roles: ["student", "instructor", "admin"] },
  instrutor: { title: "Manual do Instrutor", subtitle: "Turmas, alunos e exames", source: manualInstrutor, roles: ["instructor", "admin"] },
  administrador: { title: "Manual do Administrador de Escola", subtitle: "Utilizadores, Direção de Instrução, alertas e relatórios", source: manualAdmin, roles: ["admin"] },
  aerofleet: { title: "Manual do Aerofleet Center", subtitle: "Frota, pilotos, alertas e subscrição", source: manualAerofleet, fleet: true, roles: ["admin"] },
};

export const manualsFor = (isFleet) =>
  Object.entries(MANUALS).filter(([, m]) => (isFleet ? m.fleet : !m.fleet));

// Ligação "Ajuda" de cada painel: no domínio de frota abre sempre o manual do Aerofleet Center.
export const helpPath = (slug) => (isFleetDomain() ? "/ajuda/aerofleet" : `/ajuda/${slug}`);
